export default {
  en: { // English
    locale: "en",
    native: "English",
    modalText: {
      header: "Automatic Translation is available",
      label: "Choose Language",
      buttonTranslate: "Translate to English",
      buttonCancel: "Don't translate"
    }
  },
  es: { // Spanish
    locale: "es",
    native: "Español",
    modalText: {
      header: "Traducción automática disponible",
      label: "Elige idioma",
      buttonTranslate: "Traducir al Español",
      buttonCancel: "No traducir"
    }
  },
  fr: { // French
    locale: "fr",
    native: "Français",
    modalText: {
      header: "Traduction automatique disponible",
      label: "Choisir la langue",
      buttonTranslate: "Traduire en Français",
      buttonCancel: "Ne pas traduire"
    }
  },
  de: { // German
    locale: "de",
    native: "Deutsch",
    modalText: {
      header: "Automatische Übersetzung verfügbar",
      label: "Sprache wählen",
      buttonTranslate: "Übersetzen ins Deutsch",
      buttonCancel: "Nicht übersetzen"
    }
  },
  ja: { // Japanese
    locale: "ja",
    native: "日本語",
    modalText: {
      header: "自動翻訳が利用可能です",
      label: "言語を選択",
      buttonTranslate: "日本語に翻訳",
      buttonCancel: "翻訳しない"
    }
  },
  zh: { // Chinese
    locale: "zh",
    native: "中文",
    modalText: {
      header: "可用的自动翻译",
      label: "选择语言",
      buttonTranslate: "翻译成中文",
      buttonCancel: "不翻译"
    }
  },
  pt: { // Portuguese
    locale: "pt",
    native: "Português",
    modalText: {
      header: "Tradução automática disponível",
      label: "Escolher idioma",
      buttonTranslate: "Traduzir para Português",
      buttonCancel: "Não traduzir"
    }
  },
  ru: { // Russian
    locale: "ru",
    native: "Русский",
    modalText: {
      header: "Доступен автоматический перевод",
      label: "Выберите язык",
      buttonTranslate: "Перевести на Русский",
      buttonCancel: "Не переводить"
    }
  },
  ko: { // Korean
    locale: "ko",
    native: "한국어",
    modalText: {
      header: "자동 번역 사용 가능",
      label: "언어 선택",
      buttonTranslate: "한국어로 번역",
      buttonCancel: "번역하지 않기"
    }
  },
  ar: { // Arabic
    locale: "ar",
    native: "العربية",
    modalText: {
      header: "الترجمة التلقائية متاحة",
      label: "اختر اللغة",
      buttonTranslate: "ترجمة إلى العربية",
      buttonCancel: "لا تترجم"
    }
  },
  it: { // Italian
    locale: "it",
    native: "Italiano",
    modalText: {
      header: "Traduzione automatica disponibile",
      label: "Scegli la lingua",
      buttonTranslate: "Traduci in Italiano",
      buttonCancel: "Non tradurre"
    }
  },
  nl: { // Dutch
    locale: "nl",
    native: "Nederlands",
    modalText: {
      header: "Automatische vertaling beschikbaar",
      label: "Kies taal",
      buttonTranslate: "Vertaal naar Nederlands",
      buttonCancel: "Niet vertalen"
    }
  },
  sv: { // Swedish
    locale: "sv",
    native: "Svenska",
    modalText: {
      header: "Automatisk översättning tillgänglig",
      label: "Välj språk",
      buttonTranslate: "Översätt till Svenska",
      buttonCancel: "Översätt inte"
    }
  },
  pl: { // Polish
    locale: "pl",
    native: "Polski",
    modalText: {
      header: "Automatyczne tłumaczenie dostępne",
      label: "Wybierz język",
      buttonTranslate: "Przetłumacz na Polski",
      buttonCancel: "Nie tłumacz"
    }
  },
  tr: { // Turkish
    locale: "tr",
    native: "Türkçe",
    modalText: {
      header: "Otomatik çeviri mevcut",
      label: "Dil seçin",
      buttonTranslate: "Türkçeye çevir",
      buttonCancel: "Çevirme"
    }
  },
  th: { // Thai
    locale: "th",
    native: "ไทย",
    modalText: {
      header: "มีการแปลภาษาอัตโนมัติ",
      label: "เลือกภาษา",
      buttonTranslate: "แปลเป็นไทย",
      buttonCancel: "ไม่แปล"
    }
  },
  vi: { // Vietnamese
    locale: "vi",
    native: "Tiếng Việt",
    modalText: {
      header: "Có sẵn bản dịch tự động",
      label: "Chọn ngôn ngữ",
      buttonTranslate: "Dịch sang Tiếng Việt",
      buttonCancel: "Không dịch"
    }
  },
  id: { // Indonesian
    locale: "id",
    native: "Bahasa Indonesia",
    modalText: {
      header: "Terjemahan otomatis tersedia",
      label: "Pilih bahasa",
      buttonTranslate: "Terjemahkan ke Bahasa Indonesia",
      buttonCancel: "Jangan terjemahkan"
    }
  },
  ro: { // Romanian
    locale: "ro",
    native: "Română",
    modalText: {
      header: "Traducere automată disponibilă",
      label: "Alege limba",
      buttonTranslate: "Tradu în Română",
      buttonCancel: "Nu traduce"
    }
  },
  hu: { // Hungarian
    locale: "hu",
    native: "Magyar",
    modalText: {
      header: "Automatikus fordítás elérhető",
      label: "Válassz nyelvet",
      buttonTranslate: "Fordítás Magyarra",
      buttonCancel: "Ne fordítsd le"
    }
  },
  cs: { // Czech
    locale: "cs",
    native: "Čeština",
    modalText: {
      header: "Automatický překlad k dispozici",
      label: "Vyberte jazyk",
      buttonTranslate: "Přeložit do Češtiny",
      buttonCancel: "Nepřekládat"
    }
  },
  he: { // Hebrew
    locale: "he",
    native: "עברית",
    modalText: {
      header: "תרגום אוטומטי זמין",
      label: "בחר שפה",
      buttonTranslate: "תרגם לעברית",
      buttonCancel: "לא לתרגם"
    }
  },
  da: { // Danish
    locale: "da",
    native: "Dansk",
    modalText: {
      header: "Automatisk oversættelse tilgængelig",
      label: "Vælg sprog",
      buttonTranslate: "Oversæt til Dansk",
      buttonCancel: "Oversæt ikke"
    }
  },
  fi: { // Finnish
    locale: "fi",
    native: "Suomi",
    modalText: {
      header: "Automaattinen käännös saatavilla",
      label: "Valitse kieli",
      buttonTranslate: "Käännä Suomeksi",
      buttonCancel: "Älä käännä"
    }
  },
  el: { // Greek
    locale: "el",
    native: "Ελληνικά",
    modalText: {
      header: "Διαθέσιμη αυτόματη μετάφραση",
      label: "Επιλέξτε γλώσσα",
      buttonTranslate: "Μετάφραση στα Ελληνικά",
      buttonCancel: "Μην μεταφράζετε"
    }
  },
  uk: { // Ukrainian
    locale: "uk",
    native: "Українська",
    modalText: {
      header: "Доступний автоматичний переклад",
      label: "Виберіть мову",
      buttonTranslate: "Перекласти на Українську",
      buttonCancel: "Не перекладати"
    }
  },
  no: { // Norwegian
    locale: "no",
    native: "Norsk",
    modalText: {
      header: "Automatisk oversettelse tilgjengelig",
      label: "Velg språk",
      buttonTranslate: "Oversett til Norsk",
      buttonCancel: "Ikke oversett"
    }
  },
  hi: { // Hindi
    locale: "hi",
    native: "हिन्दी",
    modalText: {
      header: "स्वचालित अनुवाद उपलब्ध है",
      label: "भाषा चुनें",
      buttonTranslate: "हिन्दी में अनुवाद करें",
      buttonCancel: "अनुवाद न करें"
    }
  },
  ms: { // Malay
    locale: "ms",
    native: "Bahasa Melayu",
    modalText: {
      header: "Terjemahan automatik tersedia",
      label: "Pilih bahasa",
      buttonTranslate: "Terjemah ke Bahasa Melayu",
      buttonCancel: "Jangan terjemah"
    }
  },
  sr: { // Serbian
    locale: "sr",
    native: "Српски",
    modalText: {
      header: "Доступан аутоматски превод",
      label: "Изаберите језик",
      buttonTranslate: "Преведи на Српски",
      buttonCancel: "Не преводи"
    }
  },
  hr: { // Croatian
    locale: "hr",
    native: "Hrvatski",
    modalText: {
      header: "Automatski prijevod dostupan",
      label: "Odaberite jezik",
      buttonTranslate: "Prevedi na Hrvatski",
      buttonCancel: "Ne prevodi"
    }
  },
  bg: { // Bulgarian
    locale: "bg",
    native: "Български",
    modalText: {
      header: "Налично автоматично превеждане",
      label: "Изберете език",
      buttonTranslate: "Преведи на Български",
      buttonCancel: "Не превеждай"
    }
  },
  sk: { // Slovak
    locale: "sk",
    native: "Slovenčina",
    modalText: {
      header: "Automatický preklad je k dispozícii",
      label: "Vyberte jazyk",
      buttonTranslate: "Preložiť do Slovenčina",
      buttonCancel: "Neprekladať"
    }
  },
  lt: { // Lithuanian
    locale: "lt",
    native: "Lietuvių",
    modalText: {
      header: "Galimas automatinis vertimas",
      label: "Pasirinkite kalbą",
      buttonTranslate: "Išversti į Lietuvių",
      buttonCancel: "Neversti"
    }
  },
  sl: { // Slovenian
    locale: "sl",
    native: "Slovenščina",
    modalText: {
      header: "Samodejno prevajanje na voljo",
      label: "Izberite jezik",
      buttonTranslate: "Prevedi v Slovenščina",
      buttonCancel: "Ne prevajaj"
    }
  },
  lv: { // Latvian
    locale: "lv",
    native: "Latviešu",
    modalText: {
      header: "Pieejams automātiskais tulkojums",
      label: "Izvēlieties valodu",
      buttonTranslate: "Tulkot uz Latviešu",
      buttonCancel: "Netulkot"
    }
  },
  et: { // Estonian
    locale: "et",
    native: "Eesti",
    modalText: {
      header: "Automaatne tõlge saadaval",
      label: "Valige keel",
      buttonTranslate: "Tõlgi keelde Eesti",
      buttonCancel: "Ära tõlgi"
    }
  },
  bn: { // Bengali
    locale: "bn",
    native: "বাংলা",
    modalText: {
      header: "স্বয়ংক্রিয় অনুবাদ উপলব্ধ",
      label: "ভাষা নির্বাচন করুন",
      buttonTranslate: "বাংলায় অনুবাদ করুন",
      buttonCancel: "অনুবাদ করবেন না"
    }
  },
  fa: { // Persian (Farsi)
    locale: "fa",
    native: "فارسی",
    modalText: {
      header: "ترجمه خودکار در دسترس است",
      label: "زبان را انتخاب کنید",
      buttonTranslate: "ترجمه به فارسی",
      buttonCancel: "ترجمه نکنید"
    }
  },
  ur: { // Urdu
    locale: "ur",
    native: "اردو",
    modalText: {
      header: "خودکار ترجمہ دستیاب ہے",
      label: "زبان منتخب کریں",
      buttonTranslate: "اردو میں ترجمہ کریں",
      buttonCancel: "ترجمہ نہ کریں"
    }
  },
  tl: { // Tagalog (Filipino)
    locale: "tl",
    native: "Filipino",
    modalText: {
      header: "Magagamit ang Awtomatikong Pagsasalin",
      label: "Pumili ng Wika",
      buttonTranslate: "Isalin sa Filipino",
      buttonCancel: "Huwag isalin"
    }
  },
  sw: { // Swahili
    locale: "sw",
    native: "Kiswahili",
    modalText: {
      header: "Tafsiri ya moja kwa moja inapatikana",
      label: "Chagua Lugha",
      buttonTranslate: "Tafsiri kwa Kiswahili",
      buttonCancel: "Usitafsiri"
    }
  },
  ta: { // Tamil
    locale: "ta",
    native: "தமிழ்",
    modalText: {
      header: "தானியங்கி மொழிபெயர்ப்பு கிடைக்கும்",
      label: "மொழியை தேர்ந்தெடு",
      buttonTranslate: "தமிழுக்கு மொழிபெயர்க்க",
      buttonCancel: "மொழிபெயர்க்காதே"
    }
  },
  mr: { // Marathi
    locale: "mr",
    native: "मराठी",
    modalText: {
      header: "स्वयंचलित भाषांतर उपलब्ध आहे",
      label: "भाषा निवडा",
      buttonTranslate: "मराठीत भाषांतर करा",
      buttonCancel: "भाषांतर करू नका"
    }
  },
  te: { // Telugu
    locale: "te",
    native: "తెలుగు",
    modalText: {
      header: "స్వయంచాలిత అనువాదం అందుబాటులో ఉంది",
      label: "భాషను ఎంచుకోండి",
      buttonTranslate: "తెలుగులోకి అనువదించండి",
      buttonCancel: "అనువదించవద్దు"
    }
  },
  jv: { // Javanese
    locale: "jv",
    native: "ꦧꦱꦗꦮ",
    modalText: {
      header: "Terjemahan otomatis tersedia",
      label: "Pilih bahasa",
      buttonTranslate: "Terjemahkan ke ꦧꦱꦗꦮ",
      buttonCancel: "Jangan terjemahkan"
    }
  },
  my: { // Burmese
    locale: "my",
    native: "မြန်မာ",
    modalText: {
      header: "Automatik Terjemahan Tersedia",
      label: "Pilih Bahasa",
      buttonTranslate: "Terjemah Ke မြန်မာ",
      buttonCancel: "Jangan Terjemah"
    }
  },
  am: { // Amharic
    locale: "am",
    native: "አማርኛ",
    modalText: {
      header: "አውቶማቲክ እትም ስለሚገኝ",
      label: "ቋንቋን ይምረጡ",
      buttonTranslate: "ወደ አማርኛ ትርጉም",
      buttonCancel: "ትርጉም አይደለም"
    }
  }
}
